import { Log } from 'ng2-logger';
import Types, { GlobalState } from '../../models/action/core.d';
import * as Actions from '../constants/calendar';
import { ISetCalendarDatas } from '../../models/action/calendar';

const _logger = Log.create('Calendar Reducer');

const calendarReducer = (state = GlobalState().calendar, action: Types.IAction) => {
    if (!state) {
        return state;
    }
    const newState: any = {...state};
    if (action.type === Actions.actions.SET_CALENDAR_DATAS) {
        const calendarPageActionPayload = (action as unknown) as ISetCalendarDatas;
        newState.calendarDatas = calendarPageActionPayload.calendarDatas;
    }
    return Object.assign({}, state, newState);
};

export default calendarReducer;
